$ = require 'jquery'
ApiError = require 'network/api-error'
ApiPromise = undefined
queueRequire -> ApiPromise = require 'network/api-promise'
Auth = require 'db/auth'
InvitationLinkView = undefined
queueRequire -> InvitationLinkView = require 'views/invitation-link/invitation-link-view'
RequestAdminInviteView = undefined
queueRequire -> RequestAdminInviteView = require 'views/invitation-link/request-admin-invite-view'
JoinOnConfirm = undefined
queueRequire -> JoinOnConfirm = require 'lib/join-on-confirm'
ModelCache = undefined
queueRequire -> ModelCache = require 'db/model-cache'
ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
Payloads = require 'network/payloads'
Promise = require 'bluebird'
_ = require 'underscore'
{ ErrorViews } = require 'common/data/error-views'

getCookieData = (expectedType) ->
  invitationData = $.cookie('invitation') || ''
  [type, id, secret] = invitationData.split(':')
  if type != expectedType
    id = null
  { id, secret }

module.exports =
  routes: [
    ['invite/accept-board', 'handleBoardCookieInvitation']
    ['invite/accept-team', 'handleTeamCookieInvitation']
  ]

  _handleInvitation: ({ id, loadModel, targetUrl, transferUrl, viewType, apiUrl, nameFromInvite, emailRestrictionsFromInvite, modelName }) ->
    redirectIfMember = =>
      ModelLoader.await('headerData')
      .then =>
        if !Auth.isLoggedIn()
          throw ApiError.Unauthorized()
        loadModel()
      .then =>
        if (url = targetUrl())?
          @navigate url, { trigger: true }
        else
          throw ApiError.Unauthorized()

    # Immediately start fetching the invitation data
    getInvite =
      if apiUrl?
        ApiPromise
          url: apiUrl
          type: 'get'
      else
        Promise.reject(ApiError.NotFound())

    Promise.using @getSpinner(), =>
      $('#content').html('<div class="spinner loading"></div>')
      JoinOnConfirm.autoJoin()
      .then ->
        # Check to see if we're already a member of the board, in which case
        # we can go straight there.  Otherwise, go through the invitation
        # acceptance process
        redirectIfMember()
      .catch ApiError.NotFound, ApiError.Unauthorized, ApiError.Unconfirmed, =>
        @clearPreviousView()

        me = Auth.me()
        if me?
          @setViewType(me)

        @showHeader()

        Promise.props
          invite: getInvite
          member:
            if Auth.isLoggedIn()
              ModelLoader.for 'top-level', 'loadMemberLogins', Auth.myId()
        .then ({ invite }) =>
          if !invite.inviteeCanAccept
            invitationLinkView = @topLevelView RequestAdminInviteView, me,
              memberInviter: invite.memberInviter

          else
            invitationLinkView = @topLevelView InvitationLinkView, me,
              inviter: invite.memberInviter
              name: nameFromInvite(invite)
              emailRestrictions: emailRestrictionsFromInvite(invite)
              transferUrl: transferUrl?()
              willJoinOnConfirm: JoinOnConfirm.inQueue(apiUrl)
              fxJoin: ->
                ApiPromise
                  method: 'post'
                  url: apiUrl
                .then(redirectIfMember)
              fxQueueJoin: ->
                JoinOnConfirm.add(apiUrl)
              modelName: modelName

          $('#content').html(invitationLinkView.render().el)



  handleBoardInvitation: (shortLink, secret) ->
    apiUrl = if shortLink && secret
      "/1/board/#{ shortLink }/invitationSecret/#{ secret }"
    else
      null

    @_handleInvitation
      loadModel: ->
        if shortLink
          ModelLoader.for 'top-level', 'loadBoardData', shortLink, Payloads.currentBoardMinimal
        else
          throw ApiError.BadRequest('invalid board shortLink')
      targetUrl: =>
        if (board = ModelCache.get('Board', shortLink))?
          if board.isMember(Auth.me())
            return @getBoardUrl(board)
        null
      viewType: 'board-invitation-link'
      apiUrl: apiUrl
      nameFromInvite: (invite) -> invite.board.name
      emailRestrictionsFromInvite: -> []
      modelName: "Board"
    .catch ApiError, =>
      # The invitation link isn't valid anymore, show a message to that effect
      @displayErrorPage
        errorType: ErrorViews.BOARD_INVITATION_NOT_FOUND
    .done()
    return

  handleOrgInvitation: (orgName, secret) ->
    apiUrl = if orgName && secret
      "/1/organization/#{ orgName }/invitationSecret/#{ secret }"
    else
      null

    @_handleInvitation
      loadModel: ->
        if orgName
          ModelLoader.for 'top-level', 'loadOrganizationData', orgName
        else
          throw ApiError.BadRequest('invalid orgname')
      targetUrl: =>
        if (org = ModelCache.findOne 'Organization', (o) -> o.get('name') == orgName)?
          if org.isMember(Auth.me())
            return @getOrganizationUrl(orgName)
        null
      transferUrl: ->
        "/#{ orgName }/transfer-account"
      viewType: 'org-invitation-link'
      apiUrl: apiUrl
      nameFromInvite: (invite) -> invite.organization.displayName
      emailRestrictionsFromInvite: (invite) ->
        invite.organization.prefs?.orgInviteRestrict ? []
      modelName: "Team"
    .catch ApiError, (e) =>
      # The invitation link isn't valid anymore, show a message to that effect
      @displayErrorPage
        errorType: ErrorViews.ORG_INVITATION_NOT_FOUND
    .done()
    return

  handleBoardCookieInvitation: ->
    { id: shortLink, secret } = getCookieData('board')
    @handleBoardInvitation(shortLink, secret)

  handleTeamCookieInvitation: ->
    { id: orgName, secret } = getCookieData('organization')
    @handleOrgInvitation(orgName, secret)



// WEBPACK FOOTER //
// ./app/scripts/controller/invitation-routes.coffee